export type StoredImage = {
  data: ArrayBuffer;
  type: string;
  slug: string;
  id: number;
};

const connectToDb = () =>
  new Promise<IDBDatabase>((resolve, reject) => {
    try {
      const open = indexedDB.open('community-game-saved-form', 52);
      open.onupgradeneeded = () => {
        try {
          const db = open.result;
          db.onerror = reject;
          const store = db.createObjectStore('images', {
            keyPath: ['id', 'slug'],
          });
          store.createIndex('slug', 'slug');
        } catch (error) {
          reject(error);
        }
      };
      open.onerror = reject;
      open.onsuccess = () => {
        resolve(open.result);
      };
    } catch (e) {
      reject();
    }
  });

const startTransaction = (db: IDBDatabase) => {
  const tx = db.transaction('images', 'readwrite');
  const store = tx.objectStore('images');
  db.close();
  return {
    tx,
    store,
  };
};

export async function deleteImages(slug: string) {
  try {
    const db = await connectToDb();
    await new Promise((resolve, reject) => {
      const { store } = startTransaction(db);

      const cursorRequest = store.openCursor();
      cursorRequest.onsuccess = () => {
        const cursor = cursorRequest.result;
        if (cursor) {
          const value = cursor.value;
          if (value?.slug == slug) {
            cursor.delete();
          }
          cursor.continue();
        } else {
          resolve(true);
        }
      };
      cursorRequest.onerror = reject;
    });
    return true;
  } catch (e) {
    console.error(e);
  }
  return false;
}

export async function putImage(slug: string, id: number, blob: Blob) {
  try {
    const db = await connectToDb();
    const data = await blob.arrayBuffer();
    await new Promise((resolve, reject) => {
      const { store } = startTransaction(db);
      const putRequest = store.put({
        data,
        type: blob.type,
        slug,
        id,
      });
      putRequest.onsuccess = resolve;
      putRequest.onerror = reject;
    });
    return true;
  } catch (e) {
    console.error(e);
  }
  return false;
}

export async function getImages(slug: string): Promise<StoredImage[]> {
  try {
    const db = await connectToDb();
    return await new Promise((resolve, reject) => {
      const { store } = startTransaction(db);
      const getAllImages = store.getAll();
      getAllImages.onsuccess = () => {
        if (!getAllImages.result) {
          resolve([]);
        } else {
          resolve(getAllImages.result.filter((g) => g.slug == slug));
        }
      };
      getAllImages.onerror = reject;
    });
  } catch (e) {
    console.error(e);
  }
  return [];
}
